import { render, staticRenderFns } from "./ListFechamentos.vue?vue&type=template&id=bbb3a314"
import script from "./ListFechamentos.vue?vue&type=script&lang=js"
export * from "./ListFechamentos.vue?vue&type=script&lang=js"
import style0 from "./ListFechamentos.vue?vue&type=style&index=0&id=bbb3a314&prod&lang=scss"
import style1 from "./ListFechamentos.vue?vue&type=style&index=1&id=bbb3a314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports